export default __webpack_public_path__ + "static/diagram-2-a.url-41316b5761589a80d73094a60784ed8d.svg";